import { ChangeDetectionStrategy, Component, OnInit, Renderer2, TemplateRef, ViewChild, ViewEncapsulation,AfterViewInit, ChangeDetectorRef,OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';

export interface LocalNotificationModal{
  LocalNotification:[];
}

export interface LocalNotificationState {
  readonly localNotificationState: LocalNotificationModal[];
}

const NO_DATA_FOUND_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82" fill="none">
<path d="M29.5894 54.0711C43.119 54.0711 54.0869 43.1058 54.0869 29.5794C54.0869 16.053 43.119 5.08765 29.5894 5.08765C16.0597 5.08765 5.0918 16.053 5.0918 29.5794C5.0918 43.1058 16.0597 54.0711 29.5894 54.0711Z" fill="url(#paint0_linear_6628_5860)"/>
<path d="M29.3093 0.0244317C13.1532 0.00687075 0.0410161 13.0839 0.0234552 29.24C0.00589417 45.3903 13.0947 58.4966 29.2508 58.5142C45.4127 58.5318 58.5191 45.4488 58.5366 29.2986C58.5542 13.1425 45.4713 0.0419927 29.3093 0.0244317ZM29.2566 52.5376C16.402 52.5259 5.98833 42.0947 6.00004 29.2459C6.01175 16.3913 16.4488 5.98931 29.3035 6.00102C42.1639 6.01272 52.5717 16.4381 52.56 29.2927C52.5425 42.1415 42.1171 52.5493 29.2566 52.5376Z" fill="#999999"/>
<path d="M50.9049 47.152L47.2656 50.7898L54.3963 57.9235L58.0356 54.2857L50.9049 47.152Z" fill="#999999"/>
<path d="M80.5338 80.5414C78.6197 82.4555 75.5114 82.4555 73.5972 80.5414L51.1719 58.1277L58.1143 51.1912L80.5397 73.6048C82.4538 75.5131 82.4538 78.6214 80.5338 80.5414Z" fill="url(#paint1_linear_6628_5860)"/>
<path d="M45.3715 29.5797C45.3715 29.5797 38.3062 38.2489 29.5959 38.2489C20.8857 38.2489 13.8145 29.5797 13.8145 29.5797C13.8145 29.5797 20.8798 20.9104 29.5901 20.9104C38.3003 20.9104 45.3715 29.5797 45.3715 29.5797Z" fill="white"/>
<path d="M29.5898 35.6559C32.9455 35.6559 35.6659 32.9355 35.6659 29.5798C35.6659 26.224 32.9455 23.5037 29.5898 23.5037C26.234 23.5037 23.5137 26.224 23.5137 29.5798C23.5137 32.9355 26.234 35.6559 29.5898 35.6559Z" fill="#CCCCCC"/>
<path d="M29.5904 32.9921C31.4752 32.9921 33.0031 31.4642 33.0031 29.5794C33.0031 27.6947 31.4752 26.1667 29.5904 26.1667C27.7056 26.1667 26.1777 27.6947 26.1777 29.5794C26.1777 31.4642 27.7056 32.9921 29.5904 32.9921Z" fill="#666666"/>
<defs>
<linearGradient id="paint0_linear_6628_5860" x1="12.0903" y1="12.1472" x2="46.6957" y2="46.8261" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCDD1"/>
<stop offset="1" stop-color="#E4E5EA"/>
</linearGradient>
<linearGradient id="paint1_linear_6628_5860" x1="51.1723" y1="66.5801" x2="81.9738" y2="66.5801" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCDD1"/>
<stop offset="1" stop-color="#E4E5EA"/>
</linearGradient>
</defs>
</svg>
`;

export interface StepConfig {
  name: string;
  completed: boolean;
  formGroup: FormGroup;
  template: TemplateRef<any>;
  optional?: boolean;
}

@Component({
  selector: 'dl-unique-id-dialog',
  templateUrl: './unique-id-dialog.component.html',
  styleUrls: ['./unique-id-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ]
})

export class UniqueIdDialogComponent implements OnInit,AfterViewInit,OnDestroy {

  @ViewChild('firstGroup', { static: true }) public firstGroupTemplate: TemplateRef<any>;
  @ViewChild('secondGroup', { static: true }) public secondGroupTemplate: TemplateRef<any>;
  @ViewChild('stepper', { static: true }) public stepper: MatHorizontalStepper;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns: string[] = ['documentTitle', 'version', 'language', 'date','select'];
  public dataSource = new MatTableDataSource(ELEMENT_DATA);
  public dataFlag: boolean = false;
  public isLinear = false;
  public firstFormGroup = this.formBuilder.group({firstCtrl: ['', Validators.required]});
  public secondFormGroup = this.formBuilder.group({secondCtrl: ['', Validators.required]});
  public stepperConfig: StepConfig[];
  public condensed = false;
  public isCreateDisabled = true;
  public searchNotificationId= new FormControl({ value: '', disabled: false }, []);
  public isDisabled = true;
  public isDisabledSearch=true;
  public countriesFormControlOutlinedSmall = new FormControl([]);
  public notificationTypeFormControl= new FormControl('');
  public localBasedGlobalNotificationRadioButton = new FormControl();
  public countriesList = [];
  public uniqueID: any;
  public suffix: any;
  public globalID: any;
  public localIDformctrl = new FormControl({value: '', disabled: false}, [Validators.minLength(1),]);
  public globalIDformctrl= new FormControl({value: '', disabled: false}, [Validators.minLength(1),]);
  public localIdData: any;
  public flagForLocalIdCheck: boolean=false;
  public flagForglobalIdCheck:boolean=false;
  public selectedRow: any;
  public isTableShow:boolean = false;
  public checkCountryForLocalNotification = "";
  public notificationTypeList = [
    {
      label: 'SBN',
      value: 'Safety Board Notification',
      disabled: false
    },
    {
      label: 'QN',
      value: 'Quality Notification',
      disabled: false
    },
    {
      label: 'MN',
      value: 'Marketting Notification',
      disabled: false
    },
    {
      label: 'SN',
      value: 'Support Notification',
      disabled: false
    },
    {
      label: 'SNR',
      value: 'Support Notification With Risk',
      disabled: false
    },
    {
      label: 'Memo',
      value: 'Memo',
      disabled: false
    },
    {
      label: 'LN',
      value: 'Local Notification',
      disabled: false
    }
  ];

  public constructor(
    private router: Router,
    private renderer: Renderer2,
    private qnsbnService: QnSbnService,
    private changeDetectorRef: ChangeDetectorRef,
    private _QnSbnDataService:QnSbnDataService,
    private readonly oneSnackBar: OneSnackBarService,
    private readonly formBuilder: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.renderer.addClass(document.body, 'local-notification-config');
    this.iconRegistry.addSvgIconLiteral('no_data_found', this.sanitizer.bypassSecurityTrustHtml(NO_DATA_FOUND_ICON));
  }

  ngAfterViewInit(): void {   
   this.dataSource.paginator = this.paginator;
  }

  public ngOnDestroy() {
    this.renderer.removeClass(document.body, 'local-notification-config');
  }

  public ngOnInit(): void {  
    let resultData = [];
    const notificationData = this.qnsbnService.getNotificationData();
    const userInfo = this.qnsbnService.getUserAllData();
    let elCountry = {
      label : "GB",
      value : "GB"
    }
    if(Array.isArray(userInfo)) {
      if(userInfo[0].countries) {
        userInfo[0].countries.map(element => {
          elCountry = {
            label : element,
            value : element
          }
          resultData.push(elCountry);
        });
      }
    } else {
      userInfo.countries.map(element => {
        elCountry = {
          label : element,
          value : element
        }
        resultData.push(elCountry);
      });
    }
    if(resultData.length < 1) {
      resultData.push(elCountry);
    }
    this.countriesList = resultData;


    this.localIDformctrl.updateValueAndValidity()
    this.countriesFormControlOutlinedSmall.valueChanges.subscribe(inp =>{ 
      const isTypeSelected = this.notificationTypeFormControl.value === "";
      if(inp && (this.globalIDformctrl.value || this.localIDformctrl.value) && (this.localBasedGlobalNotificationRadioButton.value == 'local' || this.localBasedGlobalNotificationRadioButton.value == 'global') && !isTypeSelected){
        this.isCreateDisabled = false;
        this.isDisabledSearch = false;
       }else{
        this.isCreateDisabled = true;
        this.isDisabledSearch = true;
       } 
     });

    this.localIDformctrl.valueChanges.subscribe(enterText=>{  
      const isCountrySelected = !Array.isArray(this.countriesFormControlOutlinedSmall.value) && this.countriesFormControlOutlinedSmall.value['value'] != "";
      const isTypeSelected = this.notificationTypeFormControl.value === "";
      if(enterText && this.localBasedGlobalNotificationRadioButton.value == 'local' && isCountrySelected && !isTypeSelected){
        this.isCreateDisabled = false;
      }else{
        this.isCreateDisabled = true;
      }
     })

      //local
      this.localBasedGlobalNotificationRadioButton.valueChanges.subscribe(radiodata=>{
        if(radiodata=='global'){
          this.localIDformctrl.setValue('');
          this.isCreateDisabled = true;
        }
        this.isTableShow = false;
      })

    //global
    this.globalIDformctrl.valueChanges.subscribe(enterText=>{ 
      const isCountrySelected = !Array.isArray(this.countriesFormControlOutlinedSmall.value) && this.countriesFormControlOutlinedSmall.value['value'] != "";
      if(enterText && this.localBasedGlobalNotificationRadioButton.value == 'global' && isCountrySelected){
        this.isCreateDisabled = false;
      }else{
        this.isCreateDisabled = true;
      }
    })
    this.uniqueID = "SBN-QN-123";
    this.globalID = this.uniqueID;
    
    //glabal
    this.stepperConfig = [
      {
        name: 'Import settings',
        completed: false,
        formGroup: this.firstFormGroup,
        template: this.firstGroupTemplate,
        optional: true
      },
      {
        name: 'Verify changes',
        completed: false,
        formGroup: this.secondFormGroup,
        template: this.secondGroupTemplate
      },
    ];

    this.searchNotificationId.valueChanges.subscribe(dInput=>{
      if(dInput && this.notificationTypeFormControl.value){
        this.isDisabledSearch = false;
      }else{
        this.isDisabledSearch = true;
      }      
    });

    this.notificationTypeFormControl.valueChanges.subscribe(inp =>{ 
      this.isTableShow = false;
      const isCountrySelected = !Array.isArray(this.countriesFormControlOutlinedSmall.value) && this.countriesFormControlOutlinedSmall.value['value'] != "";
      if(inp && this.searchNotificationId.value && this.localBasedGlobalNotificationRadioButton.value == 'global' && isCountrySelected){
        this.isDisabledSearch = false;
      }else{
        this.isDisabledSearch = true;
      }
      
      if(inp && this.localIDformctrl.value && this.localBasedGlobalNotificationRadioButton.value == 'local' && isCountrySelected){
        this.isCreateDisabled = false;
      }else{
        this.isCreateDisabled = true;
      } 
    });
  }
  
  public countryCheck(){
    if(Array.isArray(this.countriesFormControlOutlinedSmall.value)){        
        this.checkCountryForLocalNotification = "";
    }else{
      return this.checkCountryForLocalNotification = this.countriesFormControlOutlinedSmall.value['value'];
    }
  }

  public addLocalNotificationId(notifyId) {
    this._QnSbnDataService.getMappedQnsbnData(notifyId,"LocalNotificationId")
  }

  public createLocalGlobalId(){

    this.countryCheck();
    const localNotificationLanguage = this.qnsbnService.getNotificationLanguage(this.checkCountryForLocalNotification);
    
    if(this.localBasedGlobalNotificationRadioButton.value=='local'){ 
      let dataObject = {
        'LocalId': this.localIDformctrl.value,
        'Country': this.checkCountryForLocalNotification,
        'LocalNotificationLanguage': localNotificationLanguage,
        'Type' : this.notificationTypeFormControl.value['label'] || ""
      }; 
      sessionStorage.setItem('reloadOverview', 'true');
      this.qnsbnService.createNotificationUniqueId(dataObject).subscribe(
        response=>{
          this.qnsbnService.setLocalNotificationID(response['LocalId']);
          this._QnSbnDataService.resetAll();
          this.addLocalNotificationId(response);
          this.oneSnackBar.open('Local Notification ID created.', OneSnackBarType.SUCCESS);         
          setTimeout(()=>{
            this.router.navigateByUrl("/create-notification")
          },1000)
        },
        (error: HttpErrorResponse) => { //409 conflicts means ID already exist.
          if(error['status'] == 409){
            this.localIDformctrl.setErrors({flagForLocalIdCheck1:false})
            this.localIDformctrl.markAsDirty();
            this.flagForLocalIdCheck = true;
            this.changeDetectorRef.detectChanges(); 
          } else{
            this.oncancelNotification();
            this.qnsbnService.httpErrorHandler(error, 'There is some issue in creating local id. Please try again later.');
          }             
        }
      );
    }

    if(this.localBasedGlobalNotificationRadioButton.value=='global'){
      let localId = this.globalID+this.globalIDformctrl.value ? this.globalID+this.globalIDformctrl.value : "";
      let dataTosend = {
        "PIMID": this.selectedRow["PIMID"],
        "UniqueSourceSystemID": this.selectedRow["UniqueSourceSystemID"]?this.selectedRow["UniqueSourceSystemID"]:"",
        "UniqueSourceDocumentID": this.selectedRow["UniqueSourceDocumentID"]?this.selectedRow["UniqueSourceDocumentID"]:"",
        "FileSize": this.selectedRow["FileSize"]?this.selectedRow["FileSize"]:"",
        "FileExtension": this.selectedRow["FileExtension"]?this.selectedRow["FileExtension"]:"",
        "Title": this.selectedRow["Title"]?this.selectedRow["Title"]:"",
        "Language": this.selectedRow["Language"]?this.selectedRow["Language"]:"en",
        "DocumentTypePIMID": this.selectedRow["DocumentTypePIMID"]?this.selectedRow["DocumentTypePIMID"]:"",
        "VersionNumber": this.selectedRow["VersionNumber"]?this.selectedRow["VersionNumber"]:"",
        "ModifyDate": this.selectedRow["ModifyDate"]?this.selectedRow["ModifyDate"]:"",
        "Subject": this.selectedRow["Subject"]?this.selectedRow["Subject"]:"",
        "IsNewestVersion": this.selectedRow["IsNewestVersion"]?this.selectedRow["IsNewestVersion"]:false,
        "DocumentType": this.selectedRow["DocumentType"]?this.selectedRow["DocumentType"]:"",
        "LocalId": localId,
        "Country": this.checkCountryForLocalNotification,
        "LocalNotificationLanguage": localNotificationLanguage
      }
      this.qnsbnService.createNotificationUniqueId(dataTosend).subscribe(
        res=>{     
          this.qnsbnService.setLocalNotificationID(res['LocalId'])
          this._QnSbnDataService.resetAll();
          this.addLocalNotificationId(res);
          this._QnSbnDataService.getMappedQnsbnData(this.selectedRow,"NotificationDoc");
          this.oneSnackBar.open('Local Notification ID created.', OneSnackBarType.SUCCESS);
          setTimeout(()=>{
            this.router.navigateByUrl("/create-notification")
          },1000)
        },
        //409 conflicts means ID already exist.
        //400 Something went wrong in request payload
        (error: HttpErrorResponse) => {
          if(error['status'] == 409){
            this.globalIDformctrl.setErrors({flagForglobalIdCheck:false})
            this.globalIDformctrl.markAsDirty();
            this.flagForglobalIdCheck = true;
            this.changeDetectorRef.detectChanges(); 
          }else{
            this.oncancelNotification();
            this.qnsbnService.httpErrorHandler(error, 'There is some issue in creating local id. Please try again later.');
          }  
        }
      );   
    }

  }
 
  toggleComplete() {
    this.stepper.selected.completed = true;
    this.stepperConfig[this.stepper.selectedIndex].completed = true;
    this.stepper.next();
  }

  rowSelection(row){
    this.selectedRow = row;
    this.uniqueID = row['Subject']
    this.globalID = this.uniqueID;
    this.toggleComplete()
  }

  onSerach(){
    let url = this.searchNotificationId.value +"&documenttype="+this.notificationTypeFormControl.value['label'] ;
    this.qnsbnService.uniqueIdPiosDocSearch(url).subscribe(
      d=>{      
        ELEMENT_DATA = d;
        this.dataSource.data = ELEMENT_DATA;
        this.dataFlag = Array.isArray(this.dataSource.data);
        this.isTableShow = true;
        this.ngAfterViewInit();
      },
      error=>{
        ELEMENT_DATA = [];
        this.dataSource.data = ELEMENT_DATA;
        this.dataFlag = Array.isArray(this.dataSource.data);
        this.isTableShow = true;
        this.ngAfterViewInit();
        this.qnsbnService.httpErrorHandler(error, 'Could not fetch any document.');
      }
    )
  }

  oncancelNotification(){
    this.router.navigateByUrl("/notification");
  }
  
}

let ELEMENT_DATA= []